import { c as _c } from "react/compiler-runtime";
import type { Color, FontVariant } from '@onefootprint/design-tokens';
import { cx } from 'class-variance-authority';
type NavigationHeaderTitleProps = {
  title?: string;
  fontVariant?: FontVariant;
  fontColor?: Color;
};
const NavigationHeaderTitle = t0 => {
  const $ = _c(4);
  const {
    title,
    fontVariant,
    fontColor
  } = t0;
  let t1;
  if ($[0] !== fontColor || $[1] !== fontVariant || $[2] !== title) {
    t1 = title ? <div className="grow max-w-[calc(100%-64px)] isolate z-[1]"><p className={cx(`text-${fontVariant || "label-2"}`, `text-${fontColor || "primary"}`, "text-center whitespace-nowrap overflow-hidden text-ellipsis fp-text")}>{title}</p></div> : null;
    $[0] = fontColor;
    $[1] = fontVariant;
    $[2] = title;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};
export default NavigationHeaderTitle;